<template>
  <div class="vue-template">
    <div class="jumbotron bg-gradient">
      <div class="container">
        <h1 class="display-4">
          Signup
        </h1>
      </div>
    </div>
    <div class="container">
      <form @submit.prevent="userRegistration">
        <div class="form-group">
          <label>Name</label>
          <input
            type="text"
            class="form-control form-control-lg"
            v-model="user.name"
          />
        </div>

        <div class="form-group">
          <label>Email</label>
          <input
            type="email"
            class="form-control form-control-lg"
            v-model="user.email"
          />
        </div>

        <div class="form-group">
          <label>Password</label>
          <input
            type="password"
            class="form-control form-control-lg"
            v-model="user.password"
          />
        </div>

        <button type="submit" class="btn btn-dark btn-lg btn-block">
          Sign Up
        </button>

        <p class="forgot-password text-right">
          Already registered
          <router-link :to="{ name: 'login' }">sign in?</router-link>
        </p>
      </form>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';
const db = firebase.firestore();

export default {
  data() {
    return {
      user: {
        name: '',
        email: '',
        password: '',
      },
    };
  },
  methods: {
    addUserToDB(name, email, uid) {
      db.collection('users')
        .doc(uid)
        .set({
          name: name,
          email: email,
        })
        .then(function() {
          // console.log('Document successfully written!');
        })
        .catch(function(error) {
          return error;
          // console.error('Error writing document: ', error);
        });
    },
    userRegistration() {
      firebase
        .auth()
        .createUserWithEmailAndPassword(this.user.email, this.user.password)
        .then(res => {
          res.user
            .updateProfile({
              displayName: this.user.name,
            })
            .then(() => {
              this.addUserToDB(this.user.name, this.user.email, res.user.uid);
            });
        })
        .catch(error => {
          alert(error.message);
        });
      this.$router.push('/');
    },
  },
};
</script>
